module.exports = __webpack_public_path__ + "img/star-sharp.487267a8.svg";